import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonRow,
  IonText,
  IonToolbar,
} from "@ionic/react";
import { close } from "ionicons/icons";
import { RequestModel } from "model";

import { translate } from "~utils";

import styles from "./AllDatesTimesModal.module.css";

type AllDatesTimesModalProps = {
  model: RequestModel;
  isScrollbarNeeded: boolean;
  onDismiss: () => void;
};

const AllDatesTimesModal: React.FC<AllDatesTimesModalProps> = ({
  model,
  isScrollbarNeeded,
  onDismiss,
}) => {
  const Container = isScrollbarNeeded ? "div" : IonContent;

  return (
    <Container>
      <IonHeader className="ion-no-border">
        <IonToolbar class={styles.toolbar}>
          <IonText slot="start">
            <h3 className="ion-padding-start">{translate("MULTI_DAY_ALL_DATES_TIMES_LABEL")}</h3>
          </IonText>
          <IonButtons slot="end">
            <IonButton fill="clear" onClick={() => onDismiss()}>
              <IonIcon slot="icon-only" color="primary" icon={close} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonGrid>
        <IonRow class={styles.gridRow}>
          <IonCol>
            <IonText>
              <h6 className="ion-padding-start ion-no-margin">{translate("LABEL_DATE")}</h6>
            </IonText>
          </IonCol>
          <IonCol>
            <IonText>
              <h6 className="ion-padding-start ion-no-margin">{translate("LABEL_START")}</h6>
            </IonText>
          </IonCol>
          <IonCol>
            <IonText>
              <h6 className="ion-padding-start ion-no-margin">{translate("LABEL_END")}</h6>
            </IonText>
          </IonCol>
        </IonRow>
        {model.getIntervals(true).map((timeObject, idx) => (
          <IonRow key={idx} class={styles.gridRow}>
            <IonCol>
              <IonText className="ion-padding-start ion-text-wrap">
                {timeObject.start.toFormat("ccc',' LLL dd")}
              </IonText>
            </IonCol>
            <IonCol>
              <IonText className="ion-padding-start ion-text-wrap">
                {timeObject.start.toFormat("t").toLowerCase()}
              </IonText>
            </IonCol>
            <IonCol>
              <IonText className="ion-padding-start ion-text-wrap">
                {timeObject.end.toFormat("t").toLowerCase()}
              </IonText>
            </IonCol>
          </IonRow>
        ))}
      </IonGrid>
    </Container>
  );
};

export default AllDatesTimesModal;
